<!--
    TestPage.vue
    Show the available details of a single test.
    by Guy E. White <guw968@g.harvard.edu>
-->
<template>
    <div id='test-page' v-if='test'>
    <div>
        <h1 data-test='test-name'>{{ test.testName }}</h1>
        <p>{{ test.testDescription }}</p>

        <!-- Dont allow adding to myTests if already present in MyTests -->
        <div v-if='!inMyTests'>
            <div v-if='!addedToMyTests'>
                <button data-test='add-to-my-tests-button' @click='addToMyTests(slug)'>Add to My Tests</button>
            </div>
        </div>

        <transition name='fade'>
            <div class='alert' v-if='addAlert'>This test has been added to My Tests!</div>
        </transition>
    </div>
</div>
</template>

<script>
import * as app from '@/common/app.js';

export default {
    name: '',
    props: ['id', 'slug'],
    data: function() {
        return {
            test: null,
            addAlert: false,
            inMyTests: false,
            addedToMyTests: false
        };
    },
    mounted: function() {
        app.api.find('tests', 'slug', this.slug).then(response => {
            this.test = response;
        });

        // Making My Tests instant a data property so we can use it later in a removeFromMyTests method
        this.mytests = new app.MyTests();
        this.tests = this.mytests.getItems();

        // On load, see if this test is already in MyTests
        for (let key of Object.keys(this.tests)) {
            if (this.tests[key].slug == this.slug) {
                this.inMyTests = true;
            }
        }
    },
    methods: {
        addToMyTests: function(slug){
            // let mytests = new app.MyTests();
            this.mytests.add(slug);

            // Update State Mangement
            this.$store.commit('updateMyTestsCount', 1);

            // Show user alert
            this.addAlert = true;
            setTimeout(() => (this.addAlert = false), 3000);

            // If added to myTests, remove the ability to add it again
            this.addedToMyTests = true;
        }
    }
};
</script>

<style scoped>
</style>
